import {createContext, useContext} from "react";

const privilegeContext = createContext();

export function usePrivilege() {
    return useContext(privilegeContext);
}

function providePrivilege(user){

    const getPrivilege = (type)=>{
        return user?.getPrivilege(type)
    }

    return {getPrivilege};
}

export default function PrivilegeProvider({ children, user }) {
    const privilege = providePrivilege(user);

    return (
        <privilegeContext.Provider value={privilege}>
            {children}
        </privilegeContext.Provider>
    );
}